import Crud from '@/views/Roles/Crud'
import Add from '@/views/Roles/Add'

const routes = {
  path: '/roles',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/roles',
      name: 'list-roles',
      component: Crud,
    },
    {
      path: '/roles/add',
      name: 'Cargos',
      component: Add,
    },
    {
      path: '/roles/edit/:id?',
      name: 'Cargos',
      component: Add,
    },
  ],
}

export default routes
